<script>
import * as sdk from '../../functions/sdk';
import { store } from '../../functions/mixins';
import UiContainer from '../ui/Container';
import UiLoading from '../ui/Loading';
import * as crossPopup from '../../functions/crossPopup';

export default {
    mixins: [store],
    components: {
        UiContainer,
        UiLoading,
    },
    data: () => ({
        sessiondId: null,
        loading: true,
        wndConnected: false,
        wndInterval: null,
    }),
    computed: {
        currentLocale() {
            return this.$i18n.locale;
        },
        modUrl() {
            const mod = this.customMods.find(i => i.id === this.$route.params.id);
            if (mod && this.sessiondId) {
                return `${mod.url}?sessionId=${this.sessiondId}&csrf=${sdk.getCsrf()}&moduleId=${mod.id}&locale=${this.currentLocale}&fRecipientList=${encodeURIComponent(sdk.getRecipientList() || '')}&style=${this.isPushwize ? 'PushwizeStyle': ''}`;
                //return `http://localhost:3000/news?sessionId=${this.sessiondId}&csrf=${sdk.getCsrf()}&moduleId=${mod.id}&locale=${this.currentLocale}&fRecipientList=${encodeURIComponent(sdk.getRecipientList() || '')}&style=${this.isPushwize ? 'PushwizeStyle': ''}`;
            } else {
                return false;
            }
        },
    },
    created() {
        crossPopup.closeAllInstances();
        this.loading = true;
        sdk.pressengerControl.getSessionId().then(sessiondId => {
            this.sessiondId = sessiondId;
        }).finally(() => {
            this.loading = false;
        });
    },
    mounted() {
        const { wndConnected } = this;
        window.addEventListener('message', this.listener);
        this.dispatch('CONNECT');
        this.wndInterval = setInterval(() => {
            this.dispatch('CONNECT');
        }, 2000);
    },
    destroyed() {
        this.wndInterval && clearInterval(this.wndInterval);
        this.wndInterval = null;
        window.removeEventListener('message', this.listener);
        window.confirmBeforeRouteChange = false;
    },
    methods: {
        listener(event) {
            const { type, payload } = event.data;
            switch(type) {
                case 'READY':
                    this.wndConnected = true;
                    this.wndInterval && clearInterval(this.wndInterval);
                    this.wndInterval = null;
                    break;
                case 'NAVIGATION_WARN':
                    window.confirmBeforeRouteChange = true;
                    break;
                case 'NAVIGATION_ALLOW':
                    window.confirmBeforeRouteChange = false;
                    break;
                case 'PUSHWIZE_PRESSAGEID':
                    console.log(`Sent to pushwize: ${payload}`);
                    window.parent.postMessage(payload, 'https://app.pushwize.com');
                    break;
                case 'REDIRECT':
                    window.confirmBeforeRouteChange = false;
                    window.location.href = payload;
                    break;
            }
        },
        dispatch(type, payload = {}) {
            //console.log(this.$refs.window ? this.$refs.window.contentWindow.source : null);
            this.$refs.window && this.$refs.window.contentWindow.postMessage({
                type,
                payload,
            }, this.modUrl);
        },
    },
}
</script>

<template>
    <ui-container class="CustomMod">
        <ui-loading v-if="loading" />
        <iframe ref="window" v-if="modUrl" :src="modUrl"></iframe>
    </ui-container>
</template>

<style lang="stylus">
@import '../../stylus/vars.styl'

.CustomMod
    height 100% !important
    width 100% !important
    padding 0 !important
    iframe
        display block
        width 100%
        height 100%
        border none
</style>
